(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["housious-category-behavior-optimized"]) return;
  try {
    
(function(){
  'use strict';

  function initDesktop(){
    var wrapper=document.querySelector('.house-header .header-top > .category-wrapper');
    if(!wrapper||wrapper.dataset.housiousOptimizedDesktop==='true') return;
    var button=wrapper.querySelector(':scope > .desktop-category-btn');
    var menu=wrapper.querySelector(':scope > .mega-menu');
    if(!button||!menu) return;
    wrapper.dataset.housiousOptimizedDesktop='true';
    document.documentElement.classList.add('js-desktop-mega-ready');
    if(!menu.id) menu.id='housious-desktop-mega-menu';
    button.setAttribute('type','button'); button.setAttribute('aria-haspopup','true');
    button.setAttribute('aria-controls',menu.id); button.setAttribute('aria-expanded','false'); menu.setAttribute('aria-hidden','true');
    var mq=window.matchMedia('(min-width:901px)');
    function focusables(){return menu.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');}
    function open(focusFirst){if(!mq.matches)return;wrapper.classList.add('is-open');button.setAttribute('aria-expanded','true');menu.setAttribute('aria-hidden','false');if(focusFirst){var a=focusables();if(a.length)a[0].focus();}}
    function close(restore){wrapper.classList.remove('is-open');button.setAttribute('aria-expanded','false');menu.setAttribute('aria-hidden','true');if(restore&&mq.matches)button.focus();}
    button.addEventListener('click',function(e){if(!mq.matches)return;e.preventDefault();e.stopPropagation();wrapper.classList.contains('is-open')?close(false):open(false);});
    button.addEventListener('keydown',function(e){if(!mq.matches)return;if(e.key==='ArrowDown'){e.preventDefault();open(true);}else if(e.key==='Escape'){e.preventDefault();close(true);}});
    menu.addEventListener('keydown',function(e){if(e.key==='Escape'&&mq.matches){e.preventDefault();close(true);}});
    document.addEventListener('pointerdown',function(e){if(mq.matches&&wrapper.classList.contains('is-open')&&!wrapper.contains(e.target))close(false);});
    document.addEventListener('focusin',function(e){if(mq.matches&&wrapper.classList.contains('is-open')&&!wrapper.contains(e.target))close(false);});
    function sync(){if(!mq.matches)close(false);} if(mq.addEventListener)mq.addEventListener('change',sync);else if(mq.addListener)mq.addListener(sync);
  }

  function initMobileA11y(){
    var categoryButton=document.querySelector('.house-header .category-btn');
    var drawer=document.querySelector('.mobile-mega-drawer');
    var overlay=document.querySelector('.mobile-mega-overlay');
    var closeButton=drawer?drawer.querySelector('.mobile-mega-close'):null;
    if(categoryButton&&drawer&&closeButton&&drawer.dataset.housiousOptimizedA11y!=='true'){
      drawer.dataset.housiousOptimizedA11y='true';
      if(!drawer.id) drawer.id='housious-mobile-category-drawer';
      var title=drawer.querySelector('.mobile-mega-header > span');
      if(title){if(!title.id)title.id='housious-mobile-category-title';title.setAttribute('data-housious-drawer-title','');title.setAttribute('role','heading');title.setAttribute('aria-level','2');title.setAttribute('tabindex','-1');}
      categoryButton.setAttribute('type','button');categoryButton.setAttribute('aria-haspopup','dialog');categoryButton.setAttribute('aria-controls',drawer.id);categoryButton.setAttribute('aria-expanded','false');
      if(!categoryButton.getAttribute('aria-label'))categoryButton.setAttribute('aria-label','Browse categories');
      drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');drawer.setAttribute('aria-hidden',drawer.classList.contains('active')?'false':'true');if(title)drawer.setAttribute('aria-labelledby',title.id);
      closeButton.setAttribute('type','button');closeButton.setAttribute('aria-label','Close categories');if(overlay)overlay.setAttribute('aria-hidden','true');
      var tabs=Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-tab'));
      tabs.forEach(function(tab){tab.setAttribute('type','button');var target=tab.getAttribute('data-target');if(target)tab.setAttribute('aria-controls',target);});
      Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-card')).forEach(function(card){var image=card.querySelector('img'),label=card.querySelector('span');if(image&&!image.getAttribute('alt')&&label)image.setAttribute('alt',label.textContent.trim());});
      var lastFocused=null,wasOpen=drawer.classList.contains('active');
      function syncTabs(){tabs.forEach(function(tab){if(tab.classList.contains('active'))tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});}
      function syncState(restore){var isOpen=drawer.classList.contains('active');categoryButton.setAttribute('aria-expanded',isOpen?'true':'false');drawer.setAttribute('aria-hidden',isOpen?'false':'true');document.documentElement.classList.toggle('housious-mobile-drawer-open',isOpen);if(isOpen&&!wasOpen){lastFocused=document.activeElement;requestAnimationFrame(function(){if(title)title.focus({preventScroll:true});else closeButton.focus({preventScroll:true});});}if(!isOpen&&wasOpen&&restore!==false){requestAnimationFrame(function(){if(lastFocused&&document.contains(lastFocused)&&typeof lastFocused.focus==='function')lastFocused.focus({preventScroll:true});else categoryButton.focus({preventScroll:true});});}wasOpen=isOpen;syncTabs();}
      function focusable(){return Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){return el.offsetParent!==null;});}
      drawer.addEventListener('keydown',function(e){if(!drawer.classList.contains('active'))return;if(e.key==='Escape'){e.preventDefault();closeButton.click();return;}if(e.key!=='Tab')return;var f=focusable();if(!f.length){e.preventDefault();return;}var first=f[0],last=f[f.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}});
      new MutationObserver(function(){syncState(true);}).observe(drawer,{attributes:true,attributeFilter:['class']});
      tabs.forEach(function(tab){new MutationObserver(syncTabs).observe(tab,{attributes:true,attributeFilter:['class']});});
      function closeDesktop(){if(window.innerWidth>900&&drawer.classList.contains('active'))closeButton.click();}
      window.addEventListener('resize',closeDesktop,{passive:true});window.addEventListener('orientationchange',closeDesktop);syncState(false);
    }

    var searchInput=document.getElementById('live-search-input'),searchResults=document.getElementById('live-search-results'),searchForm=document.getElementById('live-search-form');
    if(searchInput&&searchResults&&searchInput.dataset.housiousOptimizedA11y!=='true'){
      searchInput.dataset.housiousOptimizedA11y='true';searchInput.setAttribute('aria-controls',searchResults.id);searchInput.setAttribute('aria-expanded',searchResults.classList.contains('active')?'true':'false');
      searchResults.setAttribute('role','region');searchResults.setAttribute('aria-live','polite');searchResults.setAttribute('aria-label','Search suggestions');
      if(searchForm){var searchButton=searchForm.querySelector('button[type="submit"]');if(searchButton&&!searchButton.getAttribute('aria-label'))searchButton.setAttribute('aria-label','Search');}
      new MutationObserver(function(){searchInput.setAttribute('aria-expanded',searchResults.classList.contains('active')?'true':'false');}).observe(searchResults,{attributes:true,attributeFilter:['class']});
    }
  }

  function initScrollSync(){
    if(window.innerWidth>900)return;var drawer=document.querySelector('.mobile-mega-drawer');
    if(!drawer||drawer.dataset.housiousOptimizedScroll==='true')return;
    var scroller=drawer.querySelector('#mobile-mega-scroll-container');
    var sections=Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-section'));
    var tabs=Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-tab'));
    if(!scroller||!sections.length||!tabs.length)return;drawer.dataset.housiousOptimizedScroll='true';
    var raf=0,active=-1;
    function indexAtScroll(){var top=scroller.scrollTop,max=Math.max(0,scroller.scrollHeight-scroller.clientHeight);if(top<=4)return 0;if(top>=max-4)return sections.length-1;var line=scroller.getBoundingClientRect().top+Math.min(110,scroller.clientHeight*.28),idx=0;for(var i=0;i<sections.length;i++){if(sections[i].getBoundingClientRect().top<=line)idx=i;else break;}return idx;}
    function update(){raf=0;var idx=indexAtScroll();if(idx===active)return;active=idx;tabs.forEach(function(tab,i){var on=i===idx;tab.classList.toggle('active',on);if(on)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});var tab=tabs[idx],sidebar=tab&&tab.closest('.mobile-mega-sidebar');if(tab&&sidebar){var t=tab.offsetTop,b=t+tab.offsetHeight;if(t<sidebar.scrollTop)sidebar.scrollTop=t;else if(b>sidebar.scrollTop+sidebar.clientHeight)sidebar.scrollTop=b-sidebar.clientHeight;}}
    scroller.addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(update);},{passive:true});drawer.addEventListener('transitionend',function(){if(drawer.classList.contains('active'))update();});update();
  }

  function initProfile(){var account=document.querySelector('.house-header .account-box');if(account&&!account.getAttribute('aria-label'))account.setAttribute('aria-label','Customer profile');}
  function initAll(){initDesktop();initMobileA11y();initScrollSync();initProfile();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["housious-category-phase2"]) return;
  try {
    
(function () {
  function initHousiousDesktopCategories() {
    var wrapper = document.querySelector('.house-header .header-top > .category-wrapper');
    if (!wrapper || wrapper.dataset.housiousPhase2Ready === 'true') return;

    var button = wrapper.querySelector(':scope > .desktop-category-btn');
    var menu = wrapper.querySelector(':scope > .mega-menu');
    if (!button || !menu) return;

    wrapper.dataset.housiousPhase2Ready = 'true';
    document.documentElement.classList.add('js-desktop-mega-ready');

    if (!menu.id) menu.id = 'housious-desktop-mega-menu';
    button.setAttribute('type', 'button');
    button.setAttribute('aria-haspopup', 'true');
    button.setAttribute('aria-controls', menu.id);
    button.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');

    var desktopMedia = window.matchMedia('(min-width: 901px)');

    function focusableItems() {
      return menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    }

    function openMenu(options) {
      if (!desktopMedia.matches) return;
      wrapper.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');

      if (options && options.focusFirst) {
        var items = focusableItems();
        if (items.length) items[0].focus();
      }
    }

    function closeMenu(options) {
      wrapper.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');

      if (options && options.restoreFocus && desktopMedia.matches) {
        button.focus();
      }
    }

    function toggleMenu() {
      if (wrapper.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    button.addEventListener('click', function (event) {
      if (!desktopMedia.matches) return;
      event.preventDefault();
      event.stopPropagation();
      toggleMenu();
    });

    button.addEventListener('keydown', function (event) {
      if (!desktopMedia.matches) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openMenu({ focusFirst: true });
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu({ restoreFocus: true });
      }
    });

    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && desktopMedia.matches) {
        event.preventDefault();
        closeMenu({ restoreFocus: true });
      }
    });

    document.addEventListener('pointerdown', function (event) {
      if (!desktopMedia.matches || !wrapper.classList.contains('is-open')) return;
      if (!wrapper.contains(event.target)) closeMenu();
    });

    document.addEventListener('focusin', function (event) {
      if (!desktopMedia.matches || !wrapper.classList.contains('is-open')) return;
      if (!wrapper.contains(event.target)) closeMenu();
    });

    function syncViewport() {
      if (!desktopMedia.matches) closeMenu();
    }

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', syncViewport);
    } else if (desktopMedia.addListener) {
      desktopMedia.addListener(syncViewport);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHousiousDesktopCategories);
  } else {
    initHousiousDesktopCategories();
  }

  document.addEventListener('shopify:section:load', initHousiousDesktopCategories);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["housious-category-phase5"]) return;
  try {
    
(function () {
  function initHousiousPhase5() {
    var categoryButton = document.querySelector('.house-header .category-btn');
    var drawer = document.querySelector('.mobile-mega-drawer');
    var overlay = document.querySelector('.mobile-mega-overlay');
    var closeButton = drawer ? drawer.querySelector('.mobile-mega-close') : null;

    if (categoryButton && drawer && closeButton && drawer.dataset.housiousPhase5Ready !== 'true') {
      drawer.dataset.housiousPhase5Ready = 'true';

      if (!drawer.id) drawer.id = 'housious-mobile-category-drawer';

      var title = drawer.querySelector('.mobile-mega-header > span');
      if (title) {
        if (!title.id) title.id = 'housious-mobile-category-title';
        title.setAttribute('data-housious-drawer-title', '');
        title.setAttribute('role', 'heading');
        title.setAttribute('aria-level', '2');
        title.setAttribute('tabindex', '-1');
      }

      categoryButton.setAttribute('type', 'button');
      categoryButton.setAttribute('aria-haspopup', 'dialog');
      categoryButton.setAttribute('aria-controls', drawer.id);
      categoryButton.setAttribute('aria-expanded', 'false');
      if (!categoryButton.getAttribute('aria-label')) {
        categoryButton.setAttribute('aria-label', 'Browse categories');
      }

      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-hidden', drawer.classList.contains('active') ? 'false' : 'true');
      if (title) drawer.setAttribute('aria-labelledby', title.id);

      closeButton.setAttribute('type', 'button');
      closeButton.setAttribute('aria-label', 'Close categories');

      if (overlay) overlay.setAttribute('aria-hidden', 'true');

      var tabs = Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-tab'));
      tabs.forEach(function (tab) {
        tab.setAttribute('type', 'button');
        var target = tab.getAttribute('data-target');
        if (target) tab.setAttribute('aria-controls', target);
      });

      Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-card')).forEach(function (card) {
        var image = card.querySelector('img');
        var label = card.querySelector('span');
        if (image && !image.getAttribute('alt') && label) {
          image.setAttribute('alt', label.textContent.trim());
        }
      });

      var lastFocused = null;
      var wasOpen = drawer.classList.contains('active');

      function syncActiveTab() {
        tabs.forEach(function (tab) {
          if (tab.classList.contains('active')) {
            tab.setAttribute('aria-current', 'true');
          } else {
            tab.removeAttribute('aria-current');
          }
        });
      }

      function syncDrawerState(options) {
        var isOpen = drawer.classList.contains('active');
        categoryButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        document.documentElement.classList.toggle('housious-mobile-drawer-open', isOpen);

        if (isOpen && !wasOpen) {
          lastFocused = document.activeElement;
          window.requestAnimationFrame(function () {
            if (title) title.focus({ preventScroll: true });
            else closeButton.focus({ preventScroll: true });
          });
        }

        if (!isOpen && wasOpen && (!options || options.restoreFocus !== false)) {
          window.requestAnimationFrame(function () {
            if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
              lastFocused.focus({ preventScroll: true });
            } else {
              categoryButton.focus({ preventScroll: true });
            }
          });
        }

        wasOpen = isOpen;
        syncActiveTab();
      }

      function getFocusable() {
        return Array.prototype.slice.call(drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (element) {
          return element.offsetParent !== null;
        });
      }

      drawer.addEventListener('keydown', function (event) {
        if (!drawer.classList.contains('active')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeButton.click();
          return;
        }

        if (event.key !== 'Tab') return;

        var focusable = getFocusable();
        if (!focusable.length) {
          event.preventDefault();
          return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      var drawerObserver = new MutationObserver(function () {
        syncDrawerState();
      });
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

      tabs.forEach(function (tab) {
        var tabObserver = new MutationObserver(syncActiveTab);
        tabObserver.observe(tab, { attributes: true, attributeFilter: ['class'] });
      });

      function closeAboveMobileBreakpoint() {
        if (window.innerWidth > 900 && drawer.classList.contains('active')) {
          closeButton.click();
        }
      }

      window.addEventListener('resize', closeAboveMobileBreakpoint, { passive: true });
      window.addEventListener('orientationchange', closeAboveMobileBreakpoint);
      syncDrawerState({ restoreFocus: false });
    }

    var searchInput = document.getElementById('live-search-input');
    var searchResults = document.getElementById('live-search-results');
    var searchForm = document.getElementById('live-search-form');

    if (searchInput && searchResults && searchInput.dataset.housiousPhase5Ready !== 'true') {
      searchInput.dataset.housiousPhase5Ready = 'true';
      searchInput.setAttribute('aria-controls', searchResults.id);
      searchInput.setAttribute('aria-expanded', searchResults.classList.contains('active') ? 'true' : 'false');
      searchResults.setAttribute('role', 'region');
      searchResults.setAttribute('aria-live', 'polite');
      searchResults.setAttribute('aria-label', 'Search suggestions');

      if (searchForm) {
        var searchButton = searchForm.querySelector('button[type="submit"]');
        if (searchButton && !searchButton.getAttribute('aria-label')) {
          searchButton.setAttribute('aria-label', 'Search');
        }
      }

      var searchObserver = new MutationObserver(function () {
        searchInput.setAttribute('aria-expanded', searchResults.classList.contains('active') ? 'true' : 'false');
      });
      searchObserver.observe(searchResults, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHousiousPhase5);
  } else {
    initHousiousPhase5();
  }

  document.addEventListener('shopify:section:load', initHousiousPhase5);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["housious-category-scroll-sync"]) return;
  try {
    
(function () {
  function initHousiousCategoryScrollSync() {
    if (window.innerWidth > 900) return;
    var drawer = document.querySelector('.mobile-mega-drawer');
    if (!drawer || drawer.dataset.housiousScrollSyncReady === 'true') return;
    var scroller = drawer.querySelector('#mobile-mega-scroll-container');
    var sections = Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-section'));
    var tabs = Array.prototype.slice.call(drawer.querySelectorAll('.mobile-mega-tab'));
    if (!scroller || !sections.length || !tabs.length) return;
    drawer.dataset.housiousScrollSyncReady = 'true';
    var raf = 0, active = -1;
    function indexAtScroll() {
      var top = scroller.scrollTop;
      var max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      if (top <= 4) return 0;
      if (top >= max - 4) return sections.length - 1;
      var line = scroller.getBoundingClientRect().top + Math.min(110, scroller.clientHeight * .28);
      var idx = 0;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top <= line) idx = i;
        else break;
      }
      return idx;
    }
    function update() {
      raf = 0;
      var idx = indexAtScroll();
      if (idx === active) return;
      active = idx;
      tabs.forEach(function(tab, i) {
        var on = i === idx;
        tab.classList.toggle('active', on);
        if (on) tab.setAttribute('aria-current','true'); else tab.removeAttribute('aria-current');
      });
      var tab = tabs[idx], sidebar = tab && tab.closest('.mobile-mega-sidebar');
      if (tab && sidebar) {
        var t = tab.offsetTop, b = t + tab.offsetHeight;
        if (t < sidebar.scrollTop) sidebar.scrollTop = t;
        else if (b > sidebar.scrollTop + sidebar.clientHeight) sidebar.scrollTop = b - sidebar.clientHeight;
      }
    }
    scroller.addEventListener('scroll', function(){ if (!raf) raf = requestAnimationFrame(update); }, {passive:true});
    drawer.addEventListener('transitionend', function(){ if (drawer.classList.contains('active')) update(); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHousiousCategoryScrollSync, {once:true});
  else initHousiousCategoryScrollSync();
  document.addEventListener('shopify:section:load', initHousiousCategoryScrollSync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["housious-mobile-profile"]) return;
  try {
    
(function () {
  function initHousiousMobileProfile() {
    var account = document.querySelector('.house-header .account-box');
    if (!account || account.dataset.housiousMobileProfileReady === 'true') return;
    account.dataset.housiousMobileProfileReady = 'true';
    account.setAttribute('aria-label', 'Customer profile');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHousiousMobileProfile);
  } else {
    initHousiousMobileProfile();
  }
  document.addEventListener('shopify:section:load', initHousiousMobileProfile);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["housious-search-typewriter"]) return;
  try {
    
(function () {
  function initHousiousSearchTypewriter() {
    var input = document.getElementById('live-search-input');
    if (!input || input.dataset.housiousTypewriterReady === 'true') return;

    input.dataset.housiousTypewriterReady = 'true';

    var defaultPlaceholder = 'Search for products, categories or brands...';
    var fallbackCategories = [
      'Kitchen',
      'Home Storage',
      'Bathroom',
      'Home Furnishing',
      'Home Organizer'
    ];

    var categories = Array.prototype.slice.call(
      document.querySelectorAll('.mega-section-head h4')
    ).map(function (el) {
      return el.textContent.trim();
    }).filter(function (name, index, arr) {
      return name && arr.indexOf(name) === index;
    });

    if (!categories.length) categories = fallbackCategories;
    if (!categories.length) return;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      input.placeholder = 'Search ' + categories[0] + '...';
      return;
    }

    var categoryIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var paused = false;
    var timer = null;

    function schedule(delay) {
      window.clearTimeout(timer);
      timer = window.setTimeout(tick, delay);
    }

    function tick() {
      if (paused || input.value) return;

      var phrase = 'Search ' + categories[categoryIndex] + '...';

      if (!deleting) {
        charIndex += 1;
        input.placeholder = phrase.slice(0, charIndex);

        if (charIndex >= phrase.length) {
          deleting = true;
          schedule(1400);
          return;
        }

        schedule(65);
        return;
      }

      charIndex -= 1;
      input.placeholder = phrase.slice(0, Math.max(0, charIndex));

      if (charIndex <= 0) {
        deleting = false;
        categoryIndex = (categoryIndex + 1) % categories.length;
        schedule(300);
        return;
      }

      schedule(35);
    }

    input.addEventListener('focus', function () {
      paused = true;
      window.clearTimeout(timer);
      if (!input.value) input.placeholder = defaultPlaceholder;
    });

    input.addEventListener('input', function () {
      if (input.value) {
        input.placeholder = '';
      } else if (document.activeElement === input) {
        input.placeholder = defaultPlaceholder;
      }
    });

    input.addEventListener('blur', function () {
      if (!input.value) {
        paused = false;
        charIndex = 0;
        deleting = false;
        schedule(300);
      }
    });

    schedule(300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHousiousSearchTypewriter);
  } else {
    initHousiousSearchTypewriter();
  }

  document.addEventListener('shopify:section:load', initHousiousSearchTypewriter);
})();

  } catch(e) { console.error(e); }
})();
})();
